var that;
import JsBarcode from 'jsbarcode'
export default {

    data() {
        return {
            memberId: '',
            dhrecordList: [],
            smileImg: require("@/assets/cba/smile.png"),
            cryImg: require("@/assets/cba/cry.png"),
            waitingImg: require("@/assets/cba/waiting.png"),
        };
    },

    created() {
        that = this;
        this.memberId = this.$route.query.memberId;
        this.getWinningRecord();
    },


    mounted() {
        setTimeout(() => {
            this.generateJSBarcodeImg()
        }, 500)
    },

    methods: {
        //循环生成条形码
        generateJSBarcodeImg() {
            this.dhrecordList.forEach((v, index) => {
                // if(v.verificationCode!=''){
                // 根据动态id，动态赋值，动态生成条形码
                JsBarcode('#jsbarcodeImg' + index, v.verificationCode, {
                    textPosition: 'top',
                    displayValue: true,
                    fontSize: 36,
                    background: '#1989fa00',
                    width: 2,
                    height: 30
                })
                // }

            })
        },

        // 列表接口
        getWinningRecord() {
            let flag = this.$route.query.flag;
            this.$api.getWinningRecord({
                params: {
                    memberId: this.$route.query.memberId,
                },
                success: function (res) {
                    console.log("resres1111", res);
                    console.log("flag", flag);
                    if(flag == 1){
                        that.dhrecordList = res.data.filter(item => item.projectName.indexOf('篮球') !== -1)
                    }else if(flag == 2){
                        that.dhrecordList = res.data.filter(item => item.projectName.indexOf('门票') !== -1)
                    }else{
                        that.dhrecordList = res.data;
                    }
                    console.log("dhrecordList", that.dhrecordList);
                    //that.dhrecordList = res.data
                }
            })
        },


    }
};